import React from 'react';
import { preload } from 'react-dom';
import { useNavigate } from 'react-router-dom';
import './Projects.css';
import Background from '../Images/projects-background.jpg';
import Nibbles from '../Images/Nibbles-FrontPage.png';
import AlphasMountain from '../Images/AlphasMountain-FrontPage.png';
import InfectedGame from '../Images/InfectedGame-FrontPage.png';
import PID from '../Images/PID.png';
import RoboPatch from '../Images/RoboPatch-FrontPage.png';
import AutnomousVehicle from '../Images/AutonomousVehicle-FrontPage.png';
import OTUMSAWebsite from '../Images/OTUMSAWebsite.jpg'
import NOVA from '../Images/NOVA-Frontpage.png'
import Perception from '../Images/Perception.png'
import { FaChevronDown } from 'react-icons/fa';


const Projects = () => {
  preload(Background, { as: 'image', fetchPriority: 'high' });

    const navigate = useNavigate();
    // Function to handle navigation
    const viewProject = (projectName) => {
    navigate(`/projects/${projectName}`); // Navigate to the specific project's page
    };

    const scrollToContent = () => {
        const section = document.getElementById("projects");
        section.scrollIntoView({ behavior: "smooth" });
    };

    // Array of projects for scalability
    const projectList = [
        { name: 'NOVA', image: NOVA, width: 2870, height: 1614, title: 'Neuro-Optic Versatile Android (N.O.V.A)', description: "A robotic arm that is capable of mimicking human hand movements" },
        { name: 'Perception', image: Perception, width: 1536, height: 1024, title: 'Perception', description: "Voice to CAD, your own personal Jarvis" },
        { name: 'PIDControlledBridge', image: PID, width: 4032, height: 3024, title: 'PID Controlled Bridge', description: "Balancing a mini-kart on a bridge with PID" },
        { name: 'RoboPatch', image: RoboPatch, width: 1612, height: 702, title: 'RoboPatch - Autonomous Pothole Fixer', description: "Fixing potholes with the power of robotics!" },
        { name: 'AutonomousVehicle', image: AutnomousVehicle, width: 1920, height: 1080, title: 'Small-Scale Autonomous Arduino Car', description: "Autonomous Arduino Driven Car that can avoid obstacles" },
        { name: 'GoatShelter', image: AlphasMountain, width: 1920, height: 1080, title: 'Alphas Mountain', description: "Designed and built a full scale goat shelter for the Oshawa Zoo" },
        { name: 'Nibbles', image: Nibbles, width: 1920, height: 1080, title: 'Nibbles', description: "Be up to date with your ingredient storage and available recipies!" },
        { name: 'InfectedGame', image: InfectedGame, width: 1920, height: 1080, title: 'The Infected Game', description: "An Xbox tag-themed video game designed with C++!" },
        { name: 'OTUMSA-Website', image: OTUMSAWebsite, width: 2880, height: 1360, title: 'OTUMSA Website', description: "Designed and developed a full-stack website for the OTUMSA " },
      ];


  return (
    <div className="home-container">
      {/* Top Section: Intro */}
      <div className="front-page" style={{ backgroundImage: `url(${Background})` }}>
      <div className="background-overlay"></div>
        <div className="overlay">
          <div className="overlay-content">
            <h1>Projects</h1>
            <h3>Checkout the innovative projects I've worked on over the years!</h3>
            <button className="scroll-button" onClick={scrollToContent}>
              <FaChevronDown size={30} color="white" />
            </button>
          </div>
        </div>
      </div>
      <div id="projects" className="projects">
            <div className="project-list">
                {projectList.map((project) => (
                <div
                    key={project.name}
                    className="individual-project"
                    onClick={() => viewProject(project.name)} // Handle click for the entire card
                    style={{ cursor: 'pointer' }} // Indicate clickability
                >
                    <img loading="lazy" width={project.width} height={project.height} src={project.image} alt="Project" className="project-image" />
                    <h2>{project.title}</h2>
                    <p>{project.description}</p>
                </div>
                ))}
            </div> 
        </div>
    </div>
  );
};

export default Projects;
